import { OrderPageState } from './OrderPageState';
import TTLLocalStorage from '../../utils/TTLLocalStorage';

export const ORDER_PAGE_STATE_LOCAL_STORAGE_KEY = 'order-page-state';

const getOrderPageStateStorageKey = (orderPageId: string): string => {
  return `${ORDER_PAGE_STATE_LOCAL_STORAGE_KEY}-${orderPageId}`;
};

export const getOrderPageStateFromLocalStorage = (orderPageId: string): OrderPageState | null => {
  const key = getOrderPageStateStorageKey(orderPageId);
  return TTLLocalStorage.getItem(key);
};

export const setOrderPageStateToLocalStorage = (orderPageId: string, state: OrderPageState): void => {
  const key = getOrderPageStateStorageKey(orderPageId);
  TTLLocalStorage.setItem(key, { ...state, savedQueryString: window.location.search }, 10 * 60 * 1000); // 10 minutes
};

export const clearOrderPageStateFromLocalStorage = (): void => {
  TTLLocalStorage.removeByPrefix(ORDER_PAGE_STATE_LOCAL_STORAGE_KEY);
};

const SESSION_EXPIRY_KEY = 'monkeybook-order-page-session-expiry';

const getSessionExpiryKey = (orderPageId: string): string => {
  return `${SESSION_EXPIRY_KEY}-${orderPageId}`;
};

export const setSessionExpiry = (orderPageId: string, ttlMs: number): void => {
  const key = getSessionExpiryKey(orderPageId);
  const expiry = Date.now() + ttlMs;
  localStorage.setItem(key, JSON.stringify(expiry));
};

export const getSessionTtlLeft = (orderPageId: string): number => {
  const key = getSessionExpiryKey(orderPageId);
  try {
    const expiry = JSON.parse(localStorage.getItem(key) || '0');
    return Math.max(0, expiry - Date.now());
  } catch {
    return 0;
  }
};

export const clearSessionExpiry = (orderPageId: string): void => {
  localStorage.removeItem(getSessionExpiryKey(orderPageId));
};
